import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useNotification from 'hooks/useNotification';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import TicketTasksService from 'services/TicketTasks.service';

const TicketTaskEditModal = ({
  show,
  handleClose,
  ticketId,
  data,
  agents,
  refreshTasks
}) => {
  const { showSuccessNotification, showErrorNotification } = useNotification();

  // Estado inicial vazio
  const initialState = {
    title: '',
    isGroupTitle: data?.isGroupTitle || false,
    status: false,
    agent: { id: null },
    description: '',
    deadline: ''
  };

  const [body, setBody] = useState(initialState);

  // Importante: Adicionamos um "key" para rastrear mudanças na tarefa atual
  const [currentTaskId, setCurrentTaskId] = useState(null);

  // Este useEffect é acionado quando o modal abre ou fecha
  useEffect(() => {
    if (show && data?.id) {
      // Quando o modal abre com novos dados
      setCurrentTaskId(data.id);
      setBody({
        title: data.title || '',
        isGroupTitle: false,
        status: data.status || false,
        agent: { id: data?.agent?.id || null },
        description: data.description || '',
        deadline: data.deadline
          ? data.deadline.substr(0, data.deadline.lastIndexOf(':'))
          : ''
      });
    } else if (!show) {
      // Limpa o estado quando o modal fecha
      setBody(initialState);
      setCurrentTaskId(null);
    }
  }, [show, data?.id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setBody(prevBody => ({
      ...prevBody,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const formattedBody = {
      title: body.title,
      isGroupTitle: body.isGroupTitle,
      status: body.status,
      ...(body.deadline ? { deadline: body.deadline } : {}),
      ...(body.description ? { description: body.description } : {}),
      ...(body.agent?.id ? { agent: { id: body.agent.id } } : {})
    };

    try {
      const response = await TicketTasksService.update(
        ticketId,
        data.id,
        formattedBody
      );

      if (response.id) {
        showSuccessNotification('Tarefa editada com sucesso');
        refreshTasks();
        handleClose();
      } else {
        showErrorNotification(response.userMessage || 'Erro ao editar tarefa');
      }
    } catch (error) {
      showErrorNotification('Erro ao editar tarefa');
      console.error('Erro ao editar tarefa:', error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      // Usar o ID da tarefa atual como "key" para forçar renderização completa
      key={`task-modal-${currentTaskId}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {body.isGroupTitle ? 'Editar título do grupo' : 'Editar tarefa'}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="title">
            <Form.Label>Título</Form.Label>
            <Form.Control
              type="text"
              placeholder="(Título)"
              name="title"
              value={body.title}
              onChange={handleChange}
            />
          </Form.Group>

          <Row className="mb-3">
            <Form.Group as={Col} md={5} controlId="agent">
              <Form.Label>Responsável</Form.Label>
              <Form.Select
                value={body?.agent?.id || ''}
                onChange={e =>
                  setBody({
                    ...body,
                    agent: {
                      id: e.target.value ? parseInt(e.target.value) : null
                    }
                  })
                }
              >
                <option value="">Selecione um responsável</option>
                {agents.map(agent => (
                  <option key={agent.id} value={agent.id}>
                    {agent.firstName} {agent.lastName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md={5} controlId="deadline">
              <Form.Label>Prazo</Form.Label>
              <Form.Control
                type="datetime-local"
                placeholder="(Prazo)"
                name="deadline"
                value={body.deadline || ''}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Check
                type="switch"
                label="Concluído"
                name="status"
                checked={body.status || false}
                onChange={() => setBody({ ...body, status: !body.status })}
              />
            </Form.Group>
          </Row>

          <Form.Group className="mb-3" controlId="isGroupTitle">
            <Form.Check
              type="switch"
              label="Título do grupo"
              name="isGroupTitle"
              checked={body.isGroupTitle}
              onChange={() =>
                setBody({ ...body, isGroupTitle: !body.isGroupTitle })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="description">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="(Descrição)"
              name="description"
              value={body.description || ''}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          Cancelar
        </Button>
        <Button onClick={handleSubmit}>
          <FontAwesomeIcon icon={faSave} className="me-2" />
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketTaskEditModal;
